<template>
  <v-card>
    <v-card-title class="pr-2" :style=" { backgroundColor: companyPrimaryColor }">
      <h2 style="color:white">Extension bewerken</h2>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="closeEditExtentionDialog()">
        <v-icon dark color="white">close</v-icon>
      </v-btn>
    </v-card-title>

    <v-alert
      class="pa-1 ma-0"
      v-if="feedback"
      :value="true"
      type="warning"
      >
      {{ feedback }} 
    </v-alert>

    <v-divider></v-divider>

    <v-card-text class="pa-0">
      <v-form ref="editBranchForm" lazy-validation>
        <v-container  grid-list-md fluid class="ma-0 pa-3">
          <v-layout row wrap>
            <v-flex xs12 >
              <v-text-field
                label="Naam"
                v-model="selectedExtention.name"
                :color="companyPrimaryColor"
                background-color="background"
                hide-details
                outlined
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 >
              <v-text-field
                class="pt-4"
                label="Nummer"
                v-model="selectedExtention.number"
                :rules="requiredRules"
                :color="companyPrimaryColor"
                background-color="background"
                hide-details
                outlined
                required
              ></v-text-field>
            </v-flex>
          
            <v-flex xs12 sm6 >
              <v-select
                class="pt-4"
                v-model="selectedExtention.type"
                :items="types"
                label="Type"
                item-text="name"
                item-value="id"
                :rules="requiredRules"
                :item-color="companyPrimaryColor.hex"
                :color="companyPrimaryColor.hex"
                background-color="background"       
                hide-details
                required
                outlined
              ></v-select>
            </v-flex>
            <v-flex xs12>
              <v-select
                
                class="pt-4"
                v-model="selectedExtention.branch"
                :items="branches"
                label="Locatie"
                item-text="branchName"
                item-value="id"
                :item-color="companyPrimaryColor.hex"
                :color="companyPrimaryColor.hex"
                background-color="background"    
                no-data-text="Nog geen locaties toegevoegd."   
                hide-details
                required
                outlined
                append-icon="mdi-close"
                @click:append="setNoBranch()"
              ></v-select>
            </v-flex>
          </v-layout>
        </v-container>

      </v-form>
    </v-card-text>
    <v-divider></v-divider>

    <v-card-actions>
      <v-container grid-list-md fluid class="ma-0 pa-0">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex xs12 md6 class="text-left" v-if="$vuetify.breakpoint.name != 'sm' && $vuetify.breakpoint.name != 'xs'">
            <v-btn
              outlined
              depressed
              color="#8B93A6"
              @click="closeEditExtentionDialog()"
              >
              Annuleren
            </v-btn>
          </v-flex>
          <v-flex xs12 md6 class="text-right">
            <v-btn
              :disabled=" !changed || busy" 
              :depressed="!changed || busy"  
              :dark=" changed || busy"
              :block="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs'"
              rounded 
              :color="companySecondaryColor" 
              @click="updateExtention()"
              >
              Wijzigingen opslaan
              <v-icon right dark>chevron_right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-actions>


  </v-card>
</template>

<script>
import slugify from "slugify";
import db from "../../firebase/init";
import firebase from "firebase/app";
import platform from 'platform'; 

export default {
  name: "edit-extension-form",
  props: {
    selectedExtention: Object,
    selectedExtentionOriginal: Object,
    activeCompData: Object,
    branches: Array,
    types: Array
  },
  data() {
    return {
      requiredRules: [v => !!v || "Dit veld is verplicht"],
      feedback: null,
      errors: [],
      busy: false
      
    };
  },

  methods: {
    closeEditExtentionDialog() {
      this.$emit("editExtentionDialogChange", false);
      this.feedback = null;
    },

    setNoBranch(){
      this.selectedExtention.branch = null;
    },

    updateExtention() {
      if (this.selectedExtention.number && this.selectedExtention.type) {
        this.busy = true;

        db.collection("extentions")
          .doc(this.selectedExtention.id)
          .set({
            name: this.selectedExtention.name,
            number: this.selectedExtention.number,
            type: this.selectedExtention.type,
            branch: this.selectedExtention.branch
          }, { merge: true })
          .then(() => {
            db.collection("log").add({
              time: new Date(),
              logType: "info",
              user: this.userFirstName + " " + this.userLastName,
              userType: this.userRole,
              company: this.userCompany,
              actionType: "User Action",
              software: String(platform.os),
              browser: platform.name + " " + platform.version, 
              action: "Extension bewerkt: " + this.activeCompData.name,
              extra:
                "<b>ORGINELE GEGEVENS:</b><br>" +
                "<b>Naam:</b> " +
                this.selectedExtentionOriginal.name +
                "<br>" +
                "<b>Nummer:</b> " +
                this.selectedExtentionOriginal.number +
                "<br>" +
                "<b>Type:</b> " +
                this.selectedExtentionOriginal.type +
                "<br>" +
                "<b>Locatie:</b> " +
                this.selectedExtentionOriginal.branch +
                "<br><br>" +
                "<b>AANGEPASTE GEGEVENS:</b><br>" +
                "<b>Naam:</b> " +
                this.selectedExtention.name +
                "<br>" +
                "<b>Nummer:</b> " +
                this.selectedExtention.number +
                "<br>" +
                "<b>Type:</b> " +
                this.selectedExtention.type +
                "<br>" +
                "<b>Locatie:</b> " +
                this.selectedExtention.branch
            });
          })
          .then(() => {
            this.$emit("updateData");
            this.closeEditExtentionDialog();
            this.busy = false;
            console.log("Branch succesfully updated");
          })
          .catch(error => {
            console.error("Error updating Extension: ", error);
            this.busy = false;
            db.collection("log").add({
              time: new Date(),
              logType: "error",
              user: this.userFirstName + " " + this.userLastName,
              userType: this.userRole,
              company: this.userCompany,
              actionType: "User Action",
              action: "Error updating Extension: " + this.activeCompName,
              extra: JSON.stringify(error)
            });
          });
      } else {
        this.feedback = "Vul alle velden in om een vestiging toe te voegen.";
      }
    }
  },
  computed: {
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },
    changed() {
      if (_.isEqual(this.selectedExtention, this.selectedExtentionOriginal) == false) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

